import { render, staticRenderFns } from "./RecommendHomestay.vue?vue&type=template&id=ed2b30c4&scoped=true"
import script from "./RecommendHomestay.vue?vue&type=script&lang=js"
export * from "./RecommendHomestay.vue?vue&type=script&lang=js"
import style0 from "./RecommendHomestay.vue?vue&type=style&index=0&id=ed2b30c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed2b30c4",
  null
  
)

export default component.exports